import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { CLIENT_DATA } from '@frontend/util-api-data';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const client = inject(CLIENT_DATA).name;
    const token = localStorage.getItem(`${client}token`);
    const landRoleRaw = localStorage.getItem('landRoleView');

    const headers: Record<string, string> = {};

    if ((client === 'jansen' || client === 'aks') && token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // User-Country / User-Role aus localStorage, wenn vorhanden
    if (landRoleRaw) {
      try {
        const landRole = JSON.parse(landRoleRaw);
        if (landRole?.countryId) {
          headers['User-Country'] = landRole.countryId;
        }
        if (landRole?.roleId) {
          headers['User-Role'] = landRole.roleId;
        }
      } catch (err) {
        console.warn('Invalid landRoleView in localStorage', err);
      }
    }

    if (Object.keys(headers).length > 0) {
      request = request.clone({ setHeaders: headers });
    }

    return next.handle(request);
  }
}
